import { render, staticRenderFns } from "./InfoCircleOutlineIcon.vue?vue&type=template&id=2957dafe&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports